
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import candidatesActions from "../../redux/candidates/actions";
import commonActions from "../../redux/common/actions";
import CommonOtpVerification from "./otpVerificationWrapper"; 
import Cookies from "js-cookie";
import authActions from "../../redux/auth/actions";
import keycloakService from "../../modules";

const RegistrationClosed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const statusdata = useSelector((state) => state.candidatesReducer.bypassRegistrationData);
  const MobileVerifiedDetails = useSelector((state) => state.authReducer.MobileVerifiedDetails);
  const [hasHandledVerification, setHasHandledVerification] = useState(false);
  const[candidateNotFound,setCandidateNotFound]=useState(false)


  const searchParams = new URLSearchParams(location.search);
  const courseid = searchParams.get("courseid");
  // const coursename = decodeURIComponent(searchParams.get("coursename") || "");
  // const coursename=location.state.coursename;
  const fromInternal = location.state?.forceIf || false;
  const message = searchParams.get("message");
  const [isOtpPopupOpen, setIsOtpPopupOpen] = useState(false);
  const token = Cookies.set("mhet_cnd_token",keycloakService.getToken())

  const queryString = window.location.search; 
 let coursename;
  const match = queryString.match(/coursename=(.*)/);
  if (match && match[1]) {
     coursename = decodeURIComponent(match[1]);
   
    }
    if (courseid && coursename) {
       localStorage.setItem("courseid", courseid);
    localStorage.setItem("coursename", coursename);
    }
    // Output: MAH-PGP-CET/PGO-CET/M.Sc(A&SLP)-CET/M.Sc(P&O)-CET-2025

//   const candidateid = useSelector((state)=>state.authReducer.candidateTokenDetails?.candidateid)
// useEffect(() => {
//     if (candidateid) dispatch({ type: candidatesActions.GET_ALL_COURSE_LIST });
//   }, [candidateid]);
useEffect(() => {
    dispatch({ type: authActions.GET_MOBILE_VERIFIED,payload:{navigate} });
  }, [dispatch]);
 useEffect(() => {
  if (!MobileVerifiedDetails || hasHandledVerification ) return;

  setHasHandledVerification(true);

  Cookies.set("mhet_cnd_project", "mhcet");

  if (courseid && coursename) {
    
 

    if (MobileVerifiedDetails?.mobilenoverified === true || fromInternal) {
      dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
      dispatch({
  type: candidatesActions.SET_STATUS,
  payload: true
});
localStorage.setItem("status", true);
      dispatch({
        type: candidatesActions.GET_BYPASS_REGISTRATION,
        payload: {
          navigate,
          courseid,
          coursename,
          callback: () => {
            dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
          },
        },
      });
    } else {
      dispatch({
  type: candidatesActions.SET_STATUS,
  payload: false
});
localStorage.setItem("status", false);
      dispatch({
      type: authActions.SEND_OTP_FOR_MOBILE_VERIFICATION,
      payload: {
        data: {
          mobileno: MobileVerifiedDetails?.mobileno,
          navigate
        },
      },
    });
      setIsOtpPopupOpen(true);
    }
  }
}, [
  MobileVerifiedDetails,
  fromInternal,
  courseid,
  coursename,
  dispatch,
  navigate,
  hasHandledVerification,
]);

  return (
    <>{statusdata !== "Register Now" && (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "80vh", minWidth: "100vh" }}>
        <h1 style={{ color: "black" }}>
          {statusdata
            ? statusdata
            : "Something went wrong..."}
        </h1>
      </div>)}

     
    {isOtpPopupOpen && (  <CommonOtpVerification
        open={isOtpPopupOpen}
        setOpen={setIsOtpPopupOpen}
        mobileNumber={MobileVerifiedDetails?.mobileno}
        onSuccess={() => {
          dispatch({
            type: candidatesActions.GET_BYPASS_REGISTRATION,
            payload: {
              navigate,
              courseid,
              coursename,
              callback: () => {
                dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
              },
            },
          });
        }}
      />)}


    </>
  );
};

export default RegistrationClosed;
